var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.777c-2.135.156-4.23.977-5.948 2.464l1.784 1.784a.75.75 0 1 1-1.06 1.061L4.24 6.302a10.2 10.2 0 0 0-2.464 5.948H4.19a.75.75 0 0 1 0 1.5H1.777c.156 2.135.977 4.23 2.464 5.948L5.97 17.97a.75.75 0 1 1 1.06 1.06l-2.278 2.278a.75.75 0 0 1-1.06 0c-4.59-4.588-4.59-12.028 0-16.617C8.28.103 15.72.103 20.307 4.691c4.59 4.59 4.59 12.029 0 16.617a.75.75 0 0 1-1.06 0L16.97 19.03a.75.75 0 0 1 1.06-1.06l1.729 1.728a10.2 10.2 0 0 0 2.464-5.948H19.81a.75.75 0 1 1 0-1.5h2.413a10.2 10.2 0 0 0-2.975-6.498 10.2 10.2 0 0 0-6.498-2.975V5.19a.75.75 0 0 1-1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.927 8.133a.75.75 0 0 0-1.06-1.06l-3.785 3.784a2.4 2.4 0 1 0 1.06 1.06zM12 12.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8"
  }))));
};
export default SvgSpeed;